import { render, staticRenderFns } from "./DepositAmountInput.vue?vue&type=template&id=30dfeb6a"
import script from "./DepositAmountInput.vue?vue&type=script&lang=js"
export * from "./DepositAmountInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports